<template>
  <DefaultLayout>
    <div class="text-jm_white overflow-auto text-sm p-6">
      <button
        type="button"
        @click="globalStore.changeStep(globalStore.legalConditionsReturnStep)"
        class="text-lg font-bold border-2 inline-block py-2 px-6 rounded-lg border-jm_orange text-jm_orange mb-6"
      >
        ← {{ $t("legal_acceptance.back_button") }}
      </button>
      <div v-if="isHungarian" class="space-y-4 leading-relaxed">
        <p><strong>Felhasználási feltételek</strong></p>
        <p><strong>a "Shot Machine" online játékhoz</strong></p>
        <p>
          Jelen felhasználási feltételek szabályozzák a "Shot Machine" online játékban való részvételt és annak használatát. A játékot a Mast-Jägermeister SE
          (Jägermeisterstrasse 7-15, 38296 Wolfenbüttel, Németország) műszaki szolgáltatóként biztosítja a játékot szervező vendéglátóhely részére.
        </p>
        <p><strong>Adatvédelmi tájékoztató</strong></p>
        <p>
          A játék weboldala a szolgáltatás működtetéséhez szükséges technikai adatokat kezelhet, például böngésző- és eszközinformációkat, dátumot és időpontot,
          IP-címet, valamint technikailag szükséges sütiket vagy helyi tárolóban rögzített azonosítókat. Ezek az adatok a weboldal megfelelő megjelenítéséhez,
          a játék működéséhez, a visszaélések megelőzéséhez és a technikai biztonság biztosításához szükségesek.
        </p>
        <p>
          A játékban a rendszer kezelheti a játékhoz kapcsolódó adatokat is, például a játékosok számát, a játékok számát, a játékidőt, az életkor-ellenőrzéshez
          szükséges információt, az eszköz azonosításához szükséges adatokat, valamint a játék helyére vagy időpontjára vonatkozó technikai adatokat. Az
          életkor-ellenőrzés célja annak biztosítása, hogy a játékban csak az alkoholfogyasztásra jogosult személyek vehessenek részt.
        </p>
        <p>
          Az adatkezelés címzettje lehet a játék weboldalát üzemeltető technikai szolgáltató: Brand Adventures, a Pocket Rocket GmbH márkája, Essener Strasse
          4, 66606 St. Wendel, Németország. A technikai naplóadatok és a játék működéséhez kapcsolódó adatok a szükséges ideig, legfeljebb 14 hónapig
          kerülhetnek megőrzésre. A sütik és helyi azonosítók a felhasználó eszközén maradhatnak, amíg azokat a felhasználó nem törli.
        </p>
        <p>
          Az érintetteket megilletheti a tájékoztatáshoz, hozzáféréshez, helyesbítéshez, törléshez, az adatkezelés korlátozásához, tiltakozáshoz és panasz
          benyújtásához való jog. Adatvédelmi kérdésekben a Mast-Jägermeister SE adatvédelmi tisztviselője érhető el: DATENSCHUTZ@JAEGERMEISTER.DE.
        </p>

        <p><strong>Részvételi feltételek</strong></p>
        <p><strong>1. Szervező</strong></p>
        <p>
          A játék szervezője az a vendéglátóhely, ahol a játékhoz kapcsolódó asztali kihelyezést vagy egyéb promóciós anyagot megtalálod. A játék időtartamát,
          valamint a nyeremények típusát és számát a szervező határozza meg. Részletekért fordulj az adott vendéglátóhelyhez. A játék arra is használható, hogy
          eldöntsétek, ki fizeti a következő kör jéghideg Jägermeister shotot.
        </p>
        <p>
          A Mast-Jägermeister SE a játékot a szervező megbízásából technikai szolgáltatóként üzemelteti.
        </p>
        <p><strong>2. Részvétel</strong></p>
        <p>
          A játékban olyan nagykorú, teljes cselekvőképességgel rendelkező személyek vehetnek részt, akik a szervező székhelye szerinti jog alapján jogosultak
          szeszes ital fogyasztására. A részvétel aktív internetkapcsolatot igényel; mobilhálózat használata esetén mobiladat-forgalom merülhet fel.
        </p>
        <p><strong>3. A játék menete</strong></p>
        <p>
          A résztvevők a promóciós anyagon található QR-kód beolvasásával, okostelefonjuk böngészőjén keresztül lépnek be a játék weboldalára. Egy személy
          12 órán belül csak egyszer vehet részt. Ennek ellenőrzéséhez a weboldal az okostelefon azonosításához szükséges adatokat kezelhet.
        </p>
        <p><strong>4. Idő előtti megszüntetés</strong></p>
        <p>
          A szervező bármikor megszakíthatja vagy megszüntetheti a játékot, ha annak szabályszerű lebonyolítása jogi vagy technikai okból már nem biztosítható.
        </p>
        <p><strong>5. Jogszabályok és harmadik személyek jogai</strong></p>
        <p>
          A résztvevő köteles a részvételével kapcsolatban betartani az alkalmazandó jogszabályokat és tiszteletben tartani harmadik személyek jogait.
        </p>
        <p><strong>6. Kizárás</strong></p>
        <p>
          A szervező kizárhatja a játékból azt a résztvevőt, aki megsérti a részvételi feltételeket, jogosulatlan segédeszközt használ, manipulációval szerez
          előnyt, automatikus szkripteket, hackelési eszközöket, trójai programokat vagy vírusokat alkalmaz, illetve más módon jogosulatlan előnyhöz jut.
          Ilyen esetben a nyeremény visszavonható vagy visszakövetelhető.
        </p>
        <p><strong>7. Felelősség</strong></p>
        <p>
          A szervező és a Mast-Jägermeister SE nem felel a játék lebonyolítása során bekövetkező hibákból, késedelmekből, megszakításokból, helytelen
          tartalomból, adatvesztésből, vírusokból vagy egyéb károkból eredő károkért, kivéve, ha a kárt szándékosan vagy súlyos gondatlansággal okozták. Ez a
          felelősségkorlátozás nem alkalmazandó élet, testi épség vagy egészség sérelme, illetve csalárd módon elhallgatott hiba esetén.
        </p>
        <p><strong>8. Alkalmazandó jog</strong></p>
        <p>
          A játékra a Németországi Szövetségi Köztársaság joga irányadó, kivéve, ha a szervező országának kötelezően alkalmazandó szabályai a résztvevőre
          kedvezőbb rendelkezést tartalmaznak.
        </p>
        <p><strong>9. Adatvédelem</strong></p>
        <p>
          A résztvevő személyes adatainak a játék weboldalával és a játék lebonyolításával összefüggő kezeléséről a fenti adatvédelmi tájékoztató ad
          információt.
        </p>
        <p><strong>10. Kapcsolattartó és felelős fél</strong></p>
        <p>
          A játékért az adott résztvevő vendéglátóhely felel. A játékkal kapcsolatos kérdéseket és panaszokat közvetlenül a játékot lebonyolító
          vendéglátóhelyhez kell címezni. Ez nem vonatkozik a játék weboldalán történő adatkezeléssel kapcsolatos kérdésekre; ezekben az esetekben az
          adatvédelmi tájékoztatóban megjelölt kapcsolattartók illetékesek.
        </p>
      </div>
      <template v-else>
      <p><strong>Terms of Use</strong></p>
      <p><strong>for the Online Game &bdquo;Shot Machine&rdquo;</strong></p>
      <p>&nbsp;</p>
      <p>
        These Terms of Use (the &ldquo;Terms&rdquo;) govern your participation in and use of the online game &ldquo;Shot Machine&rdquo; (the
        &ldquo;Game&rdquo;). These Terms are entered into between you and Mast-J&auml;germeister SE, Jägermeisterstra&szlig;e 7-15, 38296 Wolfenbüttel, Germany
        (&ldquo;MJSE&rdquo;). You and MJSE are each referred to as a &ldquo;Party&rdquo; and jointly the &ldquo;Parties&rdquo;.
      </p>
      <p>&nbsp;</p>
      <p><strong>Background</strong></p>
      <p>
        MJSE has developed the Game which is run on a website (the &ldquo;Game Portal&rdquo;) operated by MJSE. Participants access the Game via their
        smartphone browser by scanning a QR code printed on promotion material (e.g. table tents).
      </p>
      <p>&nbsp;</p>
      <ol>
        <li><strong>Obligations of MJSE</strong></li>
        <li>MJSE hereby gives you permission to use the Game in accordance with these Terms.</li>
        <li>MJSE operates and maintains the Game Portal as an IT service provider to enable you to offer the Game to your customers.</li>
        <li>
          MJSE provides you with promotional (print) assets equipped with a QR code that leads participants to the Game Portal. The promotional templates can be
          downloaded on the GTM Platform by your brand manager and will be handed out to you as printed assets that can be placed in your outlet.
        </li>
        <li>
          MJSE provides universal legal notices to be accessed by the participants through the Game Portal (data privacy notice; terms and conditions for
          participants). See Annexes for the template legal notices.
        </li>
      </ol>
      <p>&nbsp;</p>
      <ol start="2">
        <li><strong>Obligations of you</strong></li>
        <li>You will offer the Game in your own responsibility.</li>
        <li>
          You warrant that you will only offer the Game if
          <ol>
            <li>i) it is generally permitted under your local laws, and</li>
            <li>ii) the legal notices provided in the Annexes fulfil all local requirements.</li>
          </ol>
        </li>
      </ol>
      <p>If necessary, you will in your responsibility apply for any government license to offer the Game.</p>
      <ol>
        <li>
          You will inform MJSE of any particularities or requirements under your local laws that need to be considered in relation to the legal notices. MJSE
          may decide in its sole discretion whether it will implement changes to the legal notices accordingly.
        </li>
        <li>
          You determine the prize that can be won by the participants. Or they use it as a bet who pays the next shot of ice cold J&auml;germeister. However,
          you are only allowed to award &ldquo;J&auml;germeister&rdquo; products as prizes for winning participants.
        </li>
        <li>
          If you award &ldquo;J&auml;germeister&rdquo; beverages to winning participants, you ensure that the respective participant may consume such alcoholic
          beverages under the applicable laws.
        </li>
        <li>If you permit any other person to offer the Game, you shall procure that they adhere to these Terms.</li>
      </ol>
      <p>&nbsp;</p>
      <ol start="3">
        <li><strong> Intellectual Property</strong></li>
      </ol>
      <p>You may use the print templates that contain copyrighted material and MJSE trademarks only for the promotion of the Game.</p>
      <p><strong>&nbsp;</strong></p>
      <ol start="4">
        <li><strong> Data Protection</strong></li>
        <li>
          The Parties have concluded that they are joint controllers in relation to the processing of personal data through the Game Portal and that you act as
          a separate and independent controller with regard to any other data processing activities in connection with the performance, implementation or
          execution of the Game (e.g. age verification of participants as required under applicable laws).
        </li>
        <li>
          MJSE collects and processes the personal data of participants as set out in the privacy notice in Annex 1. You are not involved in nor responsible for
          any of these data processing activities. You shall not collect any further personal data in connection with the performance, implementation, or
          execution of the Game unless strictly necessary under the applicable laws.
        </li>
        <li>Each Party ensures the compliance with the applicable data protection laws.</li>
        <li>
          MJSE informs the participants about the particularities of the processing of personal data through the Game Portal via the privacy notice in Annex 1
          (as updated from time to time). You shall inform the participants regarding any other processing activities in connection with the performance of the
          Game insofar as you act as a separate and independent controller.
        </li>
        <li>
          MJSE fulfils the data subject rights vis-&agrave;-vis the participants insofar as the Parties act as joint controllers. MJSE will answer to potential
          data access requests. If participants direct respective requests to you, you may forward the request to MJSE for further handling. The Parties will
          agree on which Party will lead the correspondence with the data subject on a case-by-case basis. You will fulfil the data subject rights
          vis-&agrave;-vis the participants insofar as you act as separate and independent controller.
        </li>
        <li>The Parties will support each other in satisfying its potential notification obligations toward data subjects and data protection authorities.</li>
      </ol>
      <p>&nbsp;</p>
      <ol start="5">
        <li><strong> Exclusion of warranties</strong></li>
        <li>
          MJSE provides the Game and Game Portal &ldquo;as is&rdquo; and does not give any express or implied warranties. MJSE does not give any warranty of
          compliance with applicable laws, non-infringement, or any express or implied warranty of merchantability, fitness for a particular purpose, course of
          dealing and usage of trade, without limiting the foregoing, MJSE does not warrant that the Game Portal will be fail-safe, fault-tolerant,
          uninterrupted, error free, free of harmful components, or that any content will be secure or otherwise lost or damages.
        </li>
        <li>Paragraph (a) does not apply to the extent prohibited by applicable law.</li>
      </ol>
      <p>&nbsp;</p>
      <ol start="6">
        <li><strong> Liability</strong></li>
        <li>
          Subject to the following paragraphs of this Clause 6, the Parties shall not be liable to each other for damage or losses arising out of a breach of
          these Terms.
        </li>
        <li>
          You shall indemnify MJSE for losses arising out of a violation of
          <ol>
            <li>i) Clause 3 (b), and</li>
            <li>ii) local laws that you were obliged to inform MJSE about under Clause 3 (c).</li>
          </ol>
        </li>
        <li>
          The exclusion of liability does not apply to
          <ol>
            <li>i) breaches of these Terms resulting in death or personal injury.</li>
            <li>ii) intentional or grossly negligent breaches of these Terms by any party and their representatives, agents or contractors.</li>
          </ol>
        </li>
        <li>The Parties agree that for the purposes of this Clause 6, damage and losses include potential governmental fines.</li>
      </ol>
      <p>&nbsp;</p>
      <ol start="7">
        <li><strong> Term and Termination</strong></li>
        <li>The Game will be available in a predetermined and agreed period of time</li>
        <li>
          MJSE may terminate your permission to offer the Game and the access to the Game Portal before the date set out in paragraph (a)
          <ol>
            <li>i) at any time by giving 1-week written notice (including by email), or</li>
            <li>ii) by giving written notice if the other Party commits a breach of these Terms.</li>
          </ol>
        </li>
        <li>After termination, you may no longer use the print outs generated from the templates pursuant to Clause 1 (c) and must destroy them.</li>
      </ol>
      <p>&nbsp;</p>
      <ol start="8">
        <li><strong> Miscellaneous</strong></li>
        <li>
          These Terms constitute the full and complete statement of the terms agreed between the Parties with respect to the subject matter thereof and
          supersede any previous or contemporaneous agreements, understandings, or communications, whether written or verbal, relating to its subject matter.
        </li>
        <li>
          No variation of these Terms shall be effective unless it is in writing and signed by the authorised representatives of each of the Parties or via an
          online mechanism provided for such purpose by MJSE.
        </li>
        <li>The law of the Federal Republic of Germany shall govern these Terms. Place of jurisdiction is Braunschweig, Germany.</li>
        <li>No provision of these Terms shall be enforceable by any person or individual other than the Parties.</li>
        <li>
          Should one or more provisions of these Terms be or become invalid, the validity of these Terms shall remain unaffected. In such a case, the Parties
          shall be obliged to replace the invalid provision with a valid provision that comes as close as possible to the economic purpose pursued by the
          invalid provision. The same applies to any gaps in these Terms.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p><strong>Annex 1</strong></p>
      <p>&nbsp;</p>
      <p><strong>SAMPLE DATA PROTECTION NOTICE</strong></p>
      <p><strong>(International version for countries outside the EEA)</strong></p>
      <p><strong>&nbsp;</strong></p>
      <p>
        We appreciate your interest in our company.&nbsp; Data privacy is of particular importance to the Management Board of Mast-J&auml;germeister SE
        (hereinafter referred to as &ldquo;MJSE&rdquo;). This data protection notice contains information on the type, scope, and purpose of the personal data
        collected, used, and processed in connection with the game. Furthermore, data subjects are
        informed of their rights by means of this data protection notice.
      </p>
      <p>&nbsp;</p>
      <ol>
        <li><strong> NAME AND ADDRESS OF THE DATA CONTROLLERS</strong></li>
      </ol>
      <p>
        The controllers, i.e. the entities deciding on the purposes and means of the processing of personal data, are MJSE and the Game organiser in question
        (i.e. the outlet where the Game is offered).
      </p>
      <ul>
        <li><strong>Contact information of the organising outlet </strong></li>
      </ul>
      <p>Contact information for the Game organiser can be obtained on its premises.</p>
      <p><strong>1.2 Contact information of MJSE:</strong></p>
      <p>Mast-J&auml;germeister SE</p>
      <p>J&auml;germeisterstra&szlig;e 7&ndash;15</p>
      <p>38296 Wolfenb&uuml;ttel</p>
      <p>Germany</p>
      <p>Tel.: (0049) 05331810</p>
      <p>E-mail: INFO@JAEGERMEISTER.DE</p>
      <p>Website: WWW.JAGERMEISTER.COM</p>
      <p>&nbsp;</p>
      <ol start="2">
        <li><strong> CONTACT DETAILS OF MJSE&rsquo;S DATA PROTECTION OFFICER</strong></li>
      </ol>
      <p>MJSE&rsquo;s data protection officer can be contacted at:</p>
      <p>Data protection officer</p>
      <p>Mast-J&auml;germeister SE</p>
      <p>J&auml;germeisterstra&szlig;e 7&ndash;15</p>
      <p>38296 Wolfenb&uuml;ttel</p>
      <p>Germany</p>
      <p>Tel.: +49 (0)5331 81266</p>
      <p>E-mail: DATENSCHUTZ@JAEGERMEISTER.DE</p>
      <p>Website: WWW.JAGERMEISTER.COM</p>
      <p>&nbsp;</p>
      <ol start="3">
        <li><strong> COLLECTION OF GENERAL DATA AND INFORMATION </strong></li>
      </ol>
      <p>
        The Game website operated by MJSE as the technical service provider for the respective Game organiser collects a range of general use data and
        information upon each visit by a data subject or an automated system. This general data and information is stored in the log files of the server of the
        Game website. The following data may be collected: (1) the browser types and versions used, (2) the operating system used by the accessing system, (3)
        the date and time when the Game website was accessed, (4) an internet protocol address (IP address), (6) the internet service provider of the accessing
        system, and (5) other similar data and information serving to avert risks in the event of attacks on our information technology systems.
      </p>
      <p>
        When using the general data and information, the controllers do not draw any conclusions about the data subject. Instead, this information is required
        to (1) correctly deliver the content of the Game website, (2) optimise the content of the Game website and the advertising for it, (3) ensure the
        long-term functionality of the Game website, and (4) to provide law enforcement authorities with the information necessary for prosecution in the event
        of a cyber-attack. Therefore, MJSE analyses this anonymously collected data and information on one hand for statistical purposes and on the other hand
        for the purpose of increasing the data protection and data security in connection with MJSE&rsquo;s business operations, ultimately to ensure an optimal
        level of protection for the personal data that is processed. The anonymous data in the server log files is stored separately from any personal data
        provided by a data subject.
      </p>
      <p>
        The processing is carried out based on the legitimate interest of the controllers in improving the stability and functionality of the Game website and
        in order to enable the Game to be run.
      </p>
      <p>Recipients of the data:</p>
      <ol>
        <li>
          The Game website is operated by the provider Brand Adventures a brand of Pocket Rocket GmbH, Essener Stra&szlig;e 4, 66606 St. Wendel, Germany, which
          has entered into an order processing agreement with MJSE. Brand Adventures processes the data collected through the Game website in Germany.
        </li>
      </ol>
      <p>Retention period: The collected data will be deleted after 14 months.</p>
      <p>&nbsp;</p>
      <ol start="4">
        <li><strong> TECHNICALLY NECESSARY COOKIES</strong></li>
      </ol>
      <p>
        The Game website makes use of cookies. Cookies are text files that are stored in a computer system via a web browser. Many websites and servers use
        cookies. Many cookies contain a cookie ID, which acts as a unique identifier for the cookie.
      </p>
      <p>
        The use of cookies on the Game website is necessary as the content cannot be displayed correctly without it. The use of these technically necessary
        cookies is based on the legitimate interests of the controllers for the provision of the Game website.
      </p>
      <p>
        The data subject can prevent the setting of cookies by the Game website at any time by using the appropriate web browser settings and thus permanently
        refuse the setting of cookies. Furthermore, cookies that have already been set can be deleted at any time via a web browser or other software
        programmes. This is possible in all common web browsers. If the data subject deactivates the setting of cookies in the web browser used, it may not be
        possible to make full use of all the functions of the Game website.
      </p>
      <p>Recipients of the data: See under section 3.</p>
      <p>
        Retention period: Most of the cookies used are session cookies. They are automatically deleted after the end of the visit to the Game website. Other
        cookies remain stored on the end device until the user deletes them.
      </p>
      <p><strong>&nbsp;</strong></p>
      <ol start="5">
        <li><strong> COLLECTION OF SPECIFIC INFORMATION FOR THE RUNNING OF THE GAME</strong></li>
      </ol>
      <p>- Name of player</p>
      <p>- Games in total and per player (all sessions and the number of times someone started a game)</p>
      <p>- Game time</p>
      <p>
        Date of birth: To participate in the Game, the visitor must enter their date of birth. The date of birth alone does not allow any conclusions to be
        drawn about the data subject. The date of birth is processed for the purpose of age verification to exclude Game participants who are not entitled to
        consume spirits on account of their age.
      </p>
      <p>
        <strong>Smartphone</strong> ID and cookies: In addition, the controllers collect the identification number of the smartphone used by the visitor and
        cookies to uniquely identify the smartphone. This is done to verify compliance with the Game&rsquo;s terms and conditions of participation, according to
        which only one entry per person is permitted within 12 hours.
      </p>
      <p>- Node/Location =&gt; for this we need to track the IP address.</p>
      <p>- date</p>
      <p>
        - Cookies =&gt; we only save within the session e.g., the player names. Beyond the session, the session ID is stored as a "cookie" (local storage). This
        enables us to find out who comes back again. That is, who plays more often.
      </p>
      <p>
        The processing of the data in accordance with this section 5 is carried out in accordance with Art. 6(1)(b) GDPR for the purpose of running the Game in
        accordance with the terms and conditions of participation.
      </p>
      <p>Recipients of the data: See under Section 3.</p>
      <p>
        Storage period: The data collected under this Section 5 will be deleted after 14 months. The cookies set remain stored on the end device until they are
        deleted by the user.
      </p>
      <p>&nbsp;</p>
      <ol start="6">
        <li><strong> RIGHTS OF THE DATA SUBJECT</strong></li>
        <li>
          a) Right to be informed: Every data subject has the right to receive information free of charge at any time from the controllers about the personal
          data stored concerning him or her, as well as a copy of this information.
        </li>
        <li>
          b) Right to rectification: Every data subject has, the right to request the rectification without undue delay of any inaccurate personal data
          concerning him or her.
        </li>
        <li>
          c) Right to erasure (&ldquo;right to be forgotten&rdquo;): Every data subject has the right to obtain from the controller the erasure of personal data
          concerning him or her without undue delay unless there are overriding reasons for the retention of the data.
        </li>
        <li>
          d) Right to restriction of processing: Every data subject has the right to obtain a restriction of processing where one of the following conditions
          apply:
        </li>
      </ol>
      <ul>
        <li>
          the accuracy of the personal data is contested by the data subject, for a period enabling the controller to verify the accuracy of the personal data.
        </li>
        <li>the processing is unlawful, and the data subject opposes the erasure of the personal data and requests the restriction of their use instead;</li>
        <li>
          the controller no longer needs the personal data for the purposes of the processing, but they are required by the data subject for the establishment,
          exercise or defence of legal claims.
        </li>
        <li>
          the data subject has objected to the processing pending the verification whether the legitimate grounds of the controller override those of the data
          subject.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ol>
        <li>
          <strong
            >e) Right to object: every data subject has the right to object, on grounds relating to his or her situation, at any time to processing of personal
            data concerning him or her which is carried out on the basis of the legitimate interests of the controller. The data controller shall no longer
            process the personal data in the event of the objection, unless there are compelling legitimate grounds for the processing which override the
            interests, rights, and freedoms of the data subject, or the processing serves the purpose of establishing, exercising, or defending legal claims.
          </strong>
        </li>
        <li>
          g) Right to withdraw consent under data protection law: every data subject has the right to withdraw consent to the processing of personal data at any
          time. The withdrawal of consent shall not affect the lawfulness of the processing based on consent before its withdrawal.
        </li>
        <li>
          h) Furthermore, you have the right to apply to a data protection authority with complaints concerning how your personal data is processed by us, for
          instance Die Landesbeauftragte f&uuml;r den Datenschutz Niedersachsen, Prinzenstra&szlig;e 5, 30159 Hannover, Germany.
        </li>
      </ol>
      <p>
        If the data subject wishes to exercise their rights as a data subject under this section 7, they may contact the data protection officer or another
        employee of MJSE as well as the Game organiser at any time.
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>
        <u><br /> </u>
      </p>
      <p>
        <strong><u>Annex 2</u></strong>
      </p>
      <p><strong>&nbsp;</strong></p>
      <p><strong>SAMPLE TERMS AND CONDITIONS OF PARTICIPATION</strong></p>
      <p>&nbsp;</p>
      <p><strong>SECTION 1 ORGANISER</strong></p>
      <p>
        (1) The organiser of the game is the particular outlet where you find the table display or
        other advertising for the Game. The organiser shall determine the timing of the Game and the type and number of prizes. For details, please contact the
        bar in question. But you can also use the game to fight over who will have to pay for the next round of delicious Ice Cold J&auml;germeister shots.
      </p>
      <p>
        (2) Mast-J&auml;germeister SE (hereinafter referred to as &ldquo;MJSE&rdquo;) shall run the Game as a technical service provider on behalf of the
        organiser.
      </p>
      <p>&nbsp;</p>
      <p><strong>SECTION 2 PARTICIPATION</strong></p>
      <p>
        (1) Adults with full legal capacity who are entitled to consume spirits under the law of the organiser&rsquo;s place of business are eligible to
        participate. Every participant must provide accurate personal details.
      </p>
      <p>(2) Participation also requires an active internet connection. If participating via the mobile network, mobile data will be used.</p>
      <p>&nbsp;</p>
      <p><strong>SECTION 3 RUNNING OF THE GAME</strong></p>
      <p>
        (1) Participants enter the Game via MJSE Game website via their smartphone browser by scanning a QR code
        printed on promotion material (e.g. table stands).
      </p>
      <p>
        (2) Only one entry per person is permitted within 12 hours. To comply with this restriction, the identifying details of the smartphone used to
        participate will be collected via the Game website. Details of this can be found in the data protection notice for the Game.
      </p>
      <p>&nbsp;</p>
      <p><strong>SECTION 4 PREMATURE DISCONTINUATION</strong></p>
      <p>The organiser may cancel or terminate the Game at any time if proper implementation is no longer guaranteed for legal or technical reasons.</p>
      <p>&nbsp;</p>
      <p><strong>SECTION 5 COMPLIANCE WITH THE LAW/THIRD-PARTY RIGHTS</strong></p>
      <p>The participant is obliged to observe the applicable laws and all rights of third parties in connection with his/her participation.</p>
      <p>&nbsp;</p>
      <p><strong>SECTION 6 EXCLUSION FROM PARTICIPATION</strong></p>
      <p>
        In the event of a breach of these terms and conditions of participation, the organiser reserves the right to exclude participants from the Game.
        Furthermore, the organiser reserves the right to exclude who use unauthorized aids or otherwise gain an advantage through manipulation. This is the
        case, for example, if automatic scripts, hacking tools, Trojans or viruses are used, or when a participant gains an advantage through other unauthorized
        means. Prizes may be withdrawn and/or reclaimed in such cases.
      </p>
      <p>&nbsp;</p>
      <p><strong>SECTION 7 LIABILITY</strong></p>
      <p>
        (1) The organiser and MJSE shall not be liable for any damage caused by errors, delays, or interruptions in the running of the Game, incorrect content,
        loss or deletion of data, viruses, or damage caused in any other way during participation in the Game, unless such damage has been caused by the
        organiser or MJSE (including its executive bodies, employees, or agents), intentionally or through gross negligence. The above limitation of liability
        shall not apply in the event of injury to life, limb, or health or in the event of fraudulently concealed defects.
      </p>
      <p>(2) Claims under Section 7 of the present Terms and Conditions must be asserted against the organiser.</p>
      <p>&nbsp;</p>
      <p><strong>SECTION 8 APPLICABLE LAW</strong></p>
      <p>
        The Game is governed exclusively by the laws of the Federal Republic of Germany. This does not apply to regulations under the laws of the
        organiser&rsquo;s country of domicile, insofar as these are more favorable to the participant than the corresponding regulations under the laws of the
        Federal Republic of Germany.
      </p>
      <p>&nbsp;</p>
      <p><strong>SECTION 9 DATA PROTECTION</strong></p>
      <p>
        Information on the processing of the participant&rsquo;s personal data in connection with the provision of the Game website and the running of the Game
        can be found in the data protection notice for the Game.
      </p>
      <p>&nbsp;</p>
      <p><strong>SECTION 10 CONTACT PERSON AND RESPONSIBLE PARTY </strong></p>
      <p>
        The organiser with responsibility for the Game is the participating outlet in question. All questions and complaints in connection with the Game are to
        be addressed directly to the outlet running the Game. This does not apply to questions and complaints relating to data processing via the Game website.
        The contact persons for the latter questions and complaints can be found in the data protection notice for the Game.
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      </template>
    </div>
  </DefaultLayout>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import i18n from "@/plugins/i18n";
import { useGlobalStore } from "../stores/global";

const globalStore = useGlobalStore();
const isHungarian = computed(() => String(i18n.global.locale).startsWith("hu"));
</script>

<style lang="sass" scoped>
@import "@/assets/sass/main.sass"
</style>
